import { render, staticRenderFns } from "./InstitucionalHeaderSingle.vue?vue&type=template&id=196a0704&"
import script from "./InstitucionalHeaderSingle.vue?vue&type=script&lang=js&"
export * from "./InstitucionalHeaderSingle.vue?vue&type=script&lang=js&"
import style0 from "./InstitucionalHeaderSingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports